import { render, staticRenderFns } from "./FinishedProjects.vue?vue&type=template&id=99119990&scoped=true"
import script from "./FinishedProjects.vue?vue&type=script&lang=js"
export * from "./FinishedProjects.vue?vue&type=script&lang=js"
import style0 from "./FinishedProjects.vue?vue&type=style&index=0&id=99119990&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99119990",
  null
  
)

export default component.exports